import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { Timezone } from '@genesis-frontend/genesis-utilities';

@Injectable({
    providedIn: 'root'
})
export class TimezoneService {
    constructor(private httpClient: HttpClient) {}

    getTimezoneList(language: string): Observable<Timezone[]> {
        const params = new HttpParams().set('language', language);
        return this.httpClient.get<Timezone[]>('/api/timezones', { params });
    }

    getTimezoneOffset(timeZone: string): number {
        try {
            const now = new Date();
            const tzString = new Date(now.toLocaleString('en-US', { timeZone })).toLocaleString('en-US', {
                timeZone: 'UTC',
                timeZoneName: 'short'
            });
            const utcString = now.toLocaleString('en-US', { timeZone: 'UTC', timeZoneName: 'short' });

            return (Date.parse(utcString) - Date.parse(tzString)) / 60000;
        } catch (e) {
            return 0;
        }
    }
}
